<div class="globalplanning container page">
  <div class="row">
    <div class="col-3">
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <button class="btn" (click)="this.getWeek(-1)">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <div class="mx-3">Semaine {{ this.currentWeek }}</div>
          <button class="btn" (click)="this.getWeek(1)">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-12">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder=""
              [(ngModel)]="this.filterSpeakersListQuery"
              (keyup)="this.findSpeaker(); "
            />
            <label class="form-label" for="">Recherche par nom / prénom</label>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="form-floating">
            <select
              [(ngModel)]="this.filterSpeakerLang"
              class="form-select"
              name=""
              id=""
              (change)="this.findSpeaker();"
            >
              <option value="">Choix</option>
              @for (langue of this.lgu; track langue) {
<option [value]="langue.cc_code">
                {{ langue.cc_libelle }}
              </option>
}
            </select>
            <label class="form-label" for="">Langue</label>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-3">
          <div class="form-check">
            <input
              (change)="this.findSpeaker();"
              [(ngModel)]="this.filterSpeakerListGenre"
              type="radio"
              class="form-check-input"
              name="genre-filter-input"
              id="genre-filter-input-all"
              value=""
              checked
            />
            <label for="genre-filter-input-all">Tous</label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-check">
            <input
              (change)="this.findSpeaker();"
              [(ngModel)]="this.filterSpeakerListGenre"
              type="radio"
              class="form-check-input"
              name="genre-filter-input"
              id="genre-filter-input-fem"
              value="002"
            />
            <label for="genre-filter-input-fem">Féminin</label>
          </div>
        </div>
        <div class="col-4">
          <div class="form-check">
            <input
              (change)="this.findSpeaker();"
              [(ngModel)]="this.filterSpeakerListGenre"
              type="radio"
              class="form-check-input"
              name="genre-filter-input"
              id="genre-filter-input-masc"
              value="001"
            />
            <label for="genre-filter-input-masc">Masculin</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 position-relative">
          <div
            class="globalplanning__speakerslist"
            [style]="{ height: this.speakersListHeight + 'px' }"
          >
            <app-speakers-list
              [speakersList]="this.filteredSpeakersList"
              (selectEvent)="this.goToSpeakerPlanning($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-9">
      <div class="row">
        <div class="col-12">
          <div #planningWeek class="globalplanning__week">
            @if (planningLoaded) {
<div >
              @for (day of this.daysInWeek; track day) {
<div class="globalplanning__week__day">
                <div class="globalplanning__week__day__header">
                  {{ format(day, "dd MMMM yyyy") }}
                </div>
                <div class="globalplanning__week__day__details">
                  <div class="globalplanning__week__day__details__item">
                    <h6 class="text-center mb-3">En séance</h6>
                    <ul>
                      <div class="subLegend">Disponible :</div>
                      @for (d of this.filteredAvailableSpeakersDefault; track d) {

                        @if (format(day, 'EE', { locale: localeEnUs }) === d.day) {
<li>
                          {{ d.speakerLabel }}
                        </li>
}
                      
}

                      <div class="subLegend mt-2">Mise en disponibilité :</div>
                      @for (planningEvent of this.filteredPlanningEvents; track planningEvent) {

                        @if (this.hasPlanningEventToday(planningEvent, day) && planningEvent.raison === this.planningEventReasons.SEANCE) {
<li
                          class="d-flex align-items-center justify-content-between"
                         
                        >
                          {{ planningEvent.comedienne_id.prenom }}
                          {{ planningEvent.comedienne_id.nom }}
                          {{ planningEvent.comedienne_id.langue2 !== "" && planningEvent.comedienne_id.langue2 !== " " && planningEvent.comedienne_id.langue2 !== null ? "(" + planningEvent.comedienne_id.langue1 + " / " + planningEvent.comedienne_id.langue2 + ")" : "(" + planningEvent.comedienne_id.langue1 + ")" }}
                        </li>
}
                      
}

                      <div class="subLegend mt-2">Séance :</div>
                      @for (planningEvent of this.filteredPlanningEvents; track planningEvent) {

                        @if (this.hasPlanningEventToday(planningEvent, day) && planningEvent.raison === this.planningEventReasons.ON_SITE) {
<li
                          class="d-flex align-items-center justify-content-between"
                         
                        >
                          <span>
                            {{ planningEvent.comedienne_id.prenom }}
                            {{ planningEvent.comedienne_id.nom }}
                            {{ planningEvent.comedienne_id.langue2 !== "" && planningEvent.comedienne_id.langue2 !== " " && planningEvent.comedienne_id.langue2 !== null ? "(" + planningEvent.comedienne_id.langue1 + " / " + planningEvent.comedienne_id.langue2 + ")" : "(" + planningEvent.comedienne_id.langue1 + ")" }}
                          </span>
                          <span class="badge text-bg-info">
                            <i class="fa-solid fa-building-user"></i>
                            {{ format(parseISO(planningEvent.date_debut), "HH'h'mm") }}
                          </span>
                        </li>
}
                      
}
                    </ul>
                  </div>

                  <div class="globalplanning__week__day__details__aside">
                    <div class="globalplanning__week__day__details__item">
                      <h6 class="text-center mb-2">Indisponible</h6>
                      <ul>
                        @for (planningEvent of this.filteredPlanningEvents; track planningEvent) {

                          @if (this.hasPlanningEventToday(planningEvent, day) && planningEvent.raison === this.planningEventReasons.NO_SEANCE) {
<li>
                            {{ planningEvent.comedienne_id.prenom }}
                            {{ planningEvent.comedienne_id.nom }}
                          </li>
}
                        
}
                      </ul>
                    </div>
                    <div class="globalplanning__week__day__details__item">
                      <h6 class="text-center mb-2">Congés</h6>
                      <ul>
                        @for (planningEvent of this.filteredPlanningEvents; track planningEvent) {

                          @if (this.hasPlanningEventToday(planningEvent, day) && planningEvent.raison === this.planningEventReasons.LEAVE) {
<li>
                            {{ planningEvent.comedienne_id.prenom }}
                            {{ planningEvent.comedienne_id.nom }}
                          </li>
}
                        
}
                      </ul>
                    </div>
                    <div class="globalplanning__week__day__details__item">
                      <h6 class="text-center mb-2">Maladie</h6>
                      <ul>
                        @for (planningEvent of this.filteredPlanningEvents; track planningEvent) {

                          @if (this.hasPlanningEventToday(planningEvent, day) && planningEvent.raison === this.planningEventReasons.SICK_LEAVE) {
<li>
                            {{ planningEvent.comedienne_id.prenom }}
                            {{ planningEvent.comedienne_id.nom }}
                          </li>
}
                        
}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
}
            </div>
}
            @if (!planningLoaded) {
<div>
              <app-loader></app-loader>
            </div>
}
          </div>
        </div>
      </div>
    </div >
  </div>
</div>
